import { getExtensionFromMimeType as getExtFromMime } from '~/messages/attachmentUtils'

const getExtensionFromName = (name: string): string => {
  const base = (name || '').split(/[/\\]/).pop() || ''
  const dot = base.lastIndexOf('.')
  return dot >= 0 ? base.slice(dot).toLowerCase() : ''
}

const getExtensionFromMimeType = (mimeType: string): string => {
  return getExtFromMime(mimeType, true)
}

const isGenericPickedName = (name: string): boolean => {
  const base = (name || '').trim().toLowerCase()
  return !base || base === 'blob' || base === 'undefined'
}

export const resolvePickedFileName = (file: File): string => {
  const originalName = (file?.name || '').trim()
  const mimeType = (file?.type || '').split(';')[0].trim()
  const nameExt = getExtensionFromName(originalName)
  const mimeExt = getExtensionFromMimeType(mimeType)

  if (!isGenericPickedName(originalName) && (nameExt || !mimeExt)) {
    return originalName
  }

  const ext = nameExt || mimeExt
  const base = isGenericPickedName(originalName)
    ? 'document'
    : originalName.replace(/\.[^.]+$/, '') || 'document'
  return ext ? `${base}${ext}` : base
}

export const normalizePickedFile = async (file: File): Promise<File> => {
  if (!file) {
    return file
  }

  const finalName = resolvePickedFileName(file)
  const mimeType = (file.type || '').split(';')[0].trim() || 'application/octet-stream'

  if (finalName === (file.name || '').trim()) {
    return file
  }

  try {
    const buffer = await file.arrayBuffer()
    return new File([buffer], finalName, {
      type: mimeType,
      lastModified: file.lastModified || Date.now(),
    })
  } catch {
    try {
      return new File([file], finalName, {
        type: mimeType,
        lastModified: file.lastModified || Date.now(),
      })
    } catch {
      const fallback: any = new Blob([file], { type: mimeType })
      fallback.name = finalName
      fallback.lastModified = file.lastModified || Date.now()
      return fallback as File
    }
  }
}
